export default "__VITE_ASSET__BRwnu4T2__"